function redirectToTarget(redirectTarget, newWindowEnabled = false) {
  try {
    const url = new URL(decodeURIComponent(redirectTarget));
    if (isUrlInWhitelist(url)) {
      if (newWindowEnabled) {
        window.open(url);
      } else {
        window.location.href = url.toString();
      }
      return true;
    }
    return false;
  } catch (error) {
    console.error('Invalid URL');
    return false;
  }
}

function isUrlInWhitelist(url) {
  const domainWhitelist = ['safetripbuilder.com', 'plancheckgo.com', 'localhost'];
  const baseDomain = getBaseDomain(url);
  return domainWhitelist.includes(baseDomain);
}

function getBaseDomain(url) {
  const { hostname } = url;
  const parts = hostname.split('.').reverse();
  if (parts[0] === 'localhost') {
    return 'localhost';
  }
  return parts.length > 1 ? `${parts[1]}.${parts[0]}` : hostname;
}

export { redirectToTarget, isUrlInWhitelist, getBaseDomain };
